// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2fC_e","list":"BalanceDue_list__3178O","listRow":"BalanceDue_listRow__1x289","total":"BalanceDue_total__3P6wp"};